export const videos = [
  {
    id: 1,
    title: "繁华似锦",
    slug: "fan-hua-si-jin",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20romance%20drama%20poster%20with%20elegant%20couple%20in%20city%20night%20scene%2C%20warm%20rose%20gold%20lighting%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%2C%20high%20quality%20film%20poster%20style&width=800&height=450&seq=video-cover-01&orientation=landscape",
    description: "一部都市情感大剧，讲述了在繁华都市中，几位年轻人面对事业与爱情的双重考验，最终收获成长与幸福的故事。剧情紧凑，演员阵容强大，画面精美。",
    views: "1280万",
    rating: 9.2,
    duration: "45分钟/集",
    totalEpisodes: 36,
    tags: ["都市", "情感", "职场", "励志"],
    source: "红桃视频",
    updatedAt: "2026-08-01",
    content: `<p>《繁华似锦》是一部2026年热播的都市情感大剧，由知名导演执导，实力派演员倾情演绎。故事围绕三位性格迥异的都市女性展开，她们在职场中拼搏，在感情中成长。</p>
<p>第一集以主角林墨从海外学成归国开始，她带着满腔热情进入一家知名设计公司，却发现自己面临着前所未有的挑战。与此同时，她的闺蜜苏晚晴在婚姻中遭遇危机，而独立坚强的女强人周安安则在事业巅峰期做出了令人意外的选择。</p>
<p>这部剧以细腻的笔触描绘了现代都市人的生活状态，既有职场的激烈竞争，也有感情的缠绵悱恻。每个角色都鲜活立体，让观众在追剧的同时也能产生强烈的共鸣。</p>`
  },
  {
    id: 2,
    title: "星际迷航：新纪元",
    slug: "xing-ji-mi-hang-xin-ji-yuan",
    category: "scifi",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20movie%20poster%20with%20starship%20and%20nebula%20galaxy%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20professional%20film%20poster%20style%20with%20warm%20highlights&width=800&height=450&seq=video-cover-02&orientation=landscape",
    description: "科幻巨制，人类首次远征外太空，探索未知星系。震撼的视觉效果，引人深思的哲学主题，年度必看科幻大片。",
    views: "2560万",
    rating: 9.5,
    duration: "148分钟",
    totalEpisodes: 1,
    tags: ["科幻", "太空", "冒险", "特效"],
    source: "樱桃视频",
    updatedAt: "2026-07-28",
    content: `<p>《星际迷航：新纪元》是2026年最受期待的科幻电影之一。影片讲述了在2147年，人类面临地球资源枯竭的危机，一支由顶尖科学家和宇航员组成的探险队踏上寻找新家园的征程。</p>
<p>影片以其惊人的视觉效果和深刻的人文关怀赢得了观众的一致好评。导演巧妙地将宏大的宇宙叙事与细腻的人物情感相结合，创造出一个既令人震撼又引人深思的科幻世界。</p>
<p>特效团队耗时两年打造的星际场景堪称行业标杆，每一帧画面都如同一幅精美的艺术品。配乐由好莱坞顶级作曲家操刀，完美烘托了影片的氛围。</p>`
  },
  {
    id: 3,
    title: "舌尖上的中国：秘境寻味",
    slug: "she-jian-shang-de-zhong-guo-mi-jing",
    category: "documentary",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20traditional%20cooking%20scene%2C%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20rustic%20kitchen%20atmosphere%2C%20professional%20food%20photography%20style&width=800&height=450&seq=video-cover-03&orientation=landscape",
    description: "深入中国秘境，探寻不为人知的传统美食。每一集都是一场味蕾与视觉的双重盛宴，感受中华饮食文化的博大精深。",
    views: "980万",
    rating: 9.7,
    duration: "52分钟/集",
    totalEpisodes: 8,
    tags: ["美食", "纪录片", "文化", "传统"],
    source: "糖心视频",
    updatedAt: "2026-07-25",
    content: `<p>《舌尖上的中国：秘境寻味》是经典美食纪录片的续作。摄制组深入中国西南山区、西北戈壁、东北林海等秘境，寻找那些即将失传的传统美食技艺。</p>
<p>本季共8集，每一集聚焦一个地区的一种独特食材或烹饪技法。从云南深山里的野生菌，到新疆草原上的烤全羊，从福建海边的渔民家宴，到长白山脚下的泡菜文化，镜头记录下了最真实、最动人的美食故事。</p>
<p>导演用诗意的画面语言展现了食物与自然、食物与人的关系，让观众在垂涎欲滴的同时，也能感受到中华饮食文化的深厚底蕴。</p>`
  },
  {
    id: 4,
    title: "笑傲江湖之东方不败",
    slug: "xiao-ao-jiang-hu-dong-fang-bu-bai",
    category: "action",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20film%20poster%20with%20warrior%20in%20red%20robe%20on%20mountain%20peak%2C%20dramatic%20sunset%20sky%2C%20sword%20in%20hand%2C%20epic%20cinematic%20composition%2C%20professional%20movie%20poster&width=800&height=450&seq=video-cover-04&orientation=landscape",
    description: "经典武侠巨作全新演绎，东方不败的前世今生。顶级动作设计，华丽服装道具，带你重温江湖恩怨。",
    views: "3210万",
    rating: 9.1,
    duration: "135分钟",
    totalEpisodes: 1,
    tags: ["武侠", "动作", "古装", "经典"],
    source: "茄子视频",
    updatedAt: "2026-07-22",
    content: `<p>《笑傲江湖之东方不败》是对金庸经典武侠小说的全新银幕诠释。影片聚焦于东方不败这一传奇人物的成长经历，从普通江湖女子到日月神教教主的蜕变过程。</p>
<p>动作导演为影片设计了多场令人叹为观止的打斗场面，融合了传统武术与现代动作电影的精髓。每一场对决都经过精心编排，既有力量感又不失优雅。</p>
<p>影片在服装和场景设计上也下足了功夫，完美还原了金庸笔下的江湖世界。主演的表演入木三分，将东方不败的复杂内心世界展现得淋漓尽致。</p>`
  },
  {
    id: 5,
    title: "青春不散场",
    slug: "qing-chun-bu-san-chang",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%20with%20group%20of%20young%20students%20laughing%20on%20campus%20lawn%2C%20warm%20sunlight%2C%20nostalgic%20atmosphere%2C%20Chinese%20university%20setting%2C%20professional%20film%20poster%20style&width=800&height=450&seq=video-cover-05&orientation=landscape",
    description: "青春校园剧，四个大学好友毕业后各奔东西，十年后重聚的故事。笑中带泪，温暖治愈。",
    views: "890万",
    rating: 8.9,
    duration: "42分钟/集",
    totalEpisodes: 24,
    tags: ["校园", "青春", "友情", "成长"],
    source: "红桃视频",
    updatedAt: "2026-07-20",
    content: `<p>《青春不散场》是一部温暖治愈的青春校园剧。故事以四位大学室友的视角展开，讲述了她们从校园走向社会的十年时光。</p>
<p>剧中采用了双线叙事的手法，一条线是十年前校园里的青涩时光，另一条线是十年后她们在各自的领域中拼搏奋斗。两条线索交织在一起，既有青春的欢笑与泪水，也有成长的困惑与收获。</p>
<p>这部剧的独特之处在于它没有将青春过度美化，而是真实地呈现了年轻人面对现实时的挣扎与坚持。观众在追剧的过程中，仿佛也在回顾自己的青春岁月。</p>`
  },
  {
    id: 6,
    title: "海底两万里：深海迷踪",
    slug: "hai-di-liang-wan-li-shen-hai",
    category: "scifi",
    coverImage: "https://readdy.ai/api/search-image?query=Underwater%20deep%20sea%20exploration%20film%20poster%20with%20submarine%20and%20mysterious%20ocean%20creatures%2C%20dark%20blue%20water%20with%20bioluminescent%20lights%2C%20cinematic%20composition%2C%20mysterious%20atmosphere&width=800&height=450&seq=video-cover-06&orientation=landscape",
    description: "改编自经典科幻小说，人类在深海发现了未知文明。震撼的深海视觉效果，紧张刺激的冒险故事。",
    views: "1890万",
    rating: 9.3,
    duration: "142分钟",
    totalEpisodes: 1,
    tags: ["科幻", "冒险", "深海", "悬疑"],
    source: "樱桃视频",
    updatedAt: "2026-07-18",
    content: `<p>《海底两万里：深海迷踪》是对儒勒·凡尔纳经典科幻小说的现代改编。影片将故事背景设定在2028年，一支国际深海科考队在马里亚纳海沟发现了令人震惊的未知文明遗迹。</p>
<p>影片的深海画面堪称视觉奇观，制作团队使用了最先进的水下摄影技术，为观众呈现了一个光怪陆离的海底世界。从发光的深海生物到神秘的水下建筑，每一个画面都让人叹为观止。</p>
<p>除了震撼的视觉效果，影片还探讨了人类与未知文明接触时的伦理问题，让观众在享受视听盛宴的同时也能有所思考。</p>`
  },
  {
    id: 7,
    title: "中国书法之美",
    slug: "zhong-guo-shu-fa-zhi-mei",
    category: "documentary",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20calligraphy%20documentary%20poster%20with%20elegant%20brush%20writing%20on%20rice%20paper%2C%20ink%20stone%20and%20brush%2C%20traditional%20Chinese%20study%20room%2C%20warm%20natural%20light%2C%20artistic%20atmosphere&width=800&height=450&seq=video-cover-07&orientation=landscape",
    description: "从甲骨文到现代书法，全面展现中国书法艺术的演变历程。每一笔每一画都是千年文明的传承。",
    views: "560万",
    rating: 9.6,
    duration: "48分钟/集",
    totalEpisodes: 10,
    tags: ["文化", "书法", "艺术", "历史"],
    source: "糖心视频",
    updatedAt: "2026-07-15",
    content: `<p>《中国书法之美》是一部全面展现中国书法艺术的纪录片。从殷商时期的甲骨文，到秦汉的篆隶，再到魏晋的行草，直至现代书法家的创新之作，影片系统地梳理了中国书法三千年的发展历程。</p>
<p>本片邀请了多位国家级书法大师亲自示范，让观众近距离感受笔墨纸砚之间的艺术魅力。高清摄影将每一个笔触的细节都完美呈现，犹如一场视觉的盛宴。</p>
<p>影片还深入探访了多个书法圣地，包括西安碑林、绍兴兰亭等，让观众在欣赏书法之美的同时，也能感受到中华文化的博大精深。</p>`
  },
  {
    id: 8,
    title: "极限特工：暗影行动",
    slug: "ji-xian-te-gong-an-ying-xing-dong",
    category: "action",
    coverImage: "https://readdy.ai/api/search-image?query=Action%20spy%20thriller%20movie%20poster%20with%20agent%20in%20black%20suit%20running%20through%20city%20street%2C%20explosion%20background%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20style%20with%20warm%20tone%20highlights&width=800&height=450&seq=video-cover-08&orientation=landscape",
    description: "国际特工组织面临前所未有的危机，一场跨越全球的暗影行动即将展开。动作戏拳拳到肉，剧情反转不断。",
    views: "4560万",
    rating: 8.8,
    duration: "128分钟",
    totalEpisodes: 1,
    tags: ["动作", "特工", "谍战", "悬疑"],
    source: "茄子视频",
    updatedAt: "2026-07-12",
    content: `<p>《极限特工：暗影行动》是一部高燃动作谍战片。影片讲述了一名顶级特工在追踪一个国际犯罪组织的过程中，发现自己陷入了一个精心设计的陷阱。</p>
<p>影片的动作场面设计得相当精彩，从巴黎街头的飞车追逐，到迪拜高楼的徒手攀爬，再到东京地下赌场的近身格斗，每一场动作戏都让人肾上腺素飙升。</p>
<p>主演为了这部电影进行了长达六个月的体能和格斗训练，所有动作场面几乎都是亲自上阵，没有使用替身。这种敬业精神也为影片增添了不少真实感和震撼力。</p>`
  },
  {
    id: 9,
    title: "大国重器：天宫空间站",
    slug: "da-guo-zhong-qi-tian-gong",
    category: "documentary",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20space%20station%20documentary%20poster%20with%20Tiangong%20space%20station%20orbiting%20earth%2C%20astronauts%20working%20in%20space%2C%20stars%20and%20planet%20background%2C%20inspirational%20atmosphere%2C%20professional%20style&width=800&height=450&seq=video-cover-09&orientation=landscape",
    description: "全景记录中国空间站的建设历程，从无到有，从追赶到引领。见证中国航天事业的伟大成就。",
    views: "2150万",
    rating: 9.8,
    duration: "55分钟/集",
    totalEpisodes: 6,
    tags: ["科技", "航天", "纪录片", "中国"],
    source: "红桃视频",
    updatedAt: "2026-07-10",
    content: `<p>《大国重器：天宫空间站》是一部全景式展现中国空间站建设历程的纪录片。从2011年天宫一号发射，到2022年空间站全面建成，影片用珍贵的影像资料和深入的采访，记录了这一伟大工程的每一个重要时刻。</p>
<p>摄制组获得了中国载人航天工程办公室的独家授权，首次近距离拍摄了空间站内部的工作和生活场景。观众可以看到航天员在太空中进行科学实验、锻炼身体、甚至是在失重环境下吃饭的趣味画面。</p>
<p>影片还采访了多位参与空间站建设的科学家和工程师，讲述了那些不为人知的幕后故事。每一个技术突破的背后，都凝聚着无数航天人的智慧和汗水。</p>`
  },
  {
    id: 10,
    title: "长安十二时辰续：凤鸣岐山",
    slug: "chang-an-shi-er-shi-chen-xu",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20historical%20drama%20poster%20with%20imperial%20palace%20and%20guards%2C%20lanterns%20in%20night%20scene%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20film%20poster%20style&width=800&height=450&seq=video-cover-10&orientation=landscape",
    description: "继《长安十二时辰》之后的又一力作，大唐盛世下的暗流涌动。精良的制作，扣人心弦的剧情。",
    views: "5670万",
    rating: 9.4,
    duration: "50分钟/集",
    totalEpisodes: 40,
    tags: ["古装", "历史", "悬疑", "大唐"],
    source: "樱桃视频",
    updatedAt: "2026-07-08",
    content: `<p>《长安十二时辰续：凤鸣岐山》是现象级古装悬疑剧的续作。故事发生在安史之乱平定后的长安城，表面上恢复了往日的繁华，但暗地里各方势力已经开始新一轮的角逐。</p>
<p>本剧延续了前作精良的制作水准，从服装道具到场景布置都力求还原大唐盛世的真实面貌。剧组在横店影视城搭建了占地两万平方米的长安城场景，投资规模创下国产剧新纪录。</p>
<p>剧情方面，新一季的悬疑感更强，多条故事线相互交织，每个角色都隐藏着不为人知的秘密。观众在追剧的过程中会不断被剧情反转所震撼。</p>`
  },
  {
    id: 11,
    title: "功夫厨神",
    slug: "gong-fu-chu-shen",
    category: "action",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20cooking%20comedy%20film%20poster%20with%20chef%20performing%20kung%20fu%20in%20kitchen%2C%20flying%20ingredients%2C%20wok%20fire%2C%20dynamic%20action%2C%20warm%20vibrant%20colors%2C%20professional%20movie%20poster&width=800&height=450&seq=video-cover-11&orientation=landscape",
    description: "当功夫遇上美食，一场视觉与味觉的双重盛宴。融合了中华武术与烹饪艺术的动作喜剧，精彩绝伦。",
    views: "1530万",
    rating: 8.7,
    duration: "118分钟",
    totalEpisodes: 1,
    tags: ["动作", "喜剧", "美食", "功夫"],
    source: "茄子视频",
    updatedAt: "2026-07-05",
    content: `<p>《功夫厨神》是一部将中华武术与烹饪艺术完美融合的动作喜剧电影。影片讲述了一位身怀绝技的功夫大师，为了传承家传厨艺，在都市中开设了一家小餐馆的故事。</p>
<p>影片最大的亮点是将功夫动作与烹饪过程巧妙结合。主角用武术招式来切菜、炒菜、摆盘，每一个烹饪动作都如同行云流水般的武术表演。厨房变成了他的武道场，锅铲就是他的武器。</p>
<p>影片在让人捧腹大笑的同时，也传递了对中华传统文化的热爱。数位真正的武术冠军和米其林大厨参与了影片的制作，保证了动作和美食场景的专业水准。</p>`
  },
  {
    id: 12,
    title: "夜色温柔",
    slug: "ye-se-wen-rou",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Romantic%20night%20drama%20poster%20with%20couple%20walking%20under%20city%20streetlights%2C%20rain%20reflections%20on%20pavement%2C%20warm%20amber%20lighting%2C%20intimate%20atmosphere%2C%20cinematic%20film%20poster%20style&width=800&height=450&seq=video-cover-12&orientation=landscape",
    description: "一个发生在雨夜的爱情故事，两个陌生人的命运在城市的夜色中交织。细腻的情感描写，唯美的画面。",
    views: "760万",
    rating: 9.0,
    duration: "40分钟/集",
    totalEpisodes: 16,
    tags: ["爱情", "都市", "文艺", "治愈"],
    source: "糖心视频",
    updatedAt: "2026-07-02",
    content: `<p>《夜色温柔》是一部节奏舒缓、情感细腻的都市爱情剧。故事从一个雨夜开始，两个素不相识的年轻人在城市的天桥上相遇，从此展开了一段温柔而深刻的情感旅程。</p>
<p>导演以极其细腻的手法描绘了现代都市人的情感世界。剧中没有狗血的剧情和夸张的冲突，而是通过对日常生活的真实刻画，展现了爱情最朴素也最动人的一面。</p>
<p>影片的摄影风格独树一帜，大量运用了夜景和雨景的拍摄，营造出一种朦胧而浪漫的氛围。配乐由日本著名作曲家操刀，每一首曲子都恰到好处地烘托了剧中的情感。</p>`
  }
];

export const categories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-apps-line", count: 12 },
  { id: "drama", name: "电视剧", slug: "drama", icon: "ri-tv-line", count: 4 },
  { id: "action", name: "动作片", slug: "action", icon: "ri-swap-line", count: 3 },
  { id: "scifi", name: "科幻片", slug: "scifi", icon: "ri-rocket-line", count: 2 },
  { id: "documentary", name: "纪录片", slug: "documentary", icon: "ri-film-line", count: 3 },
];

export const hotTags = ["都市情感", "科幻巨制", "武侠经典", "美食纪录", "悬疑推理", "青春校园", "动作大片", "历史文化"];